import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterText',
  standalone: false,
})
export class FilterTextPipe implements PipeTransform {
  transform(value: any[], term = '', properties: string[] = []): any[] {
    term = term.trim().toLowerCase();
    if (!term) {
      return value;
    }
    const stringSearchProperty = properties.length === 1 ? properties[0] : '';
    return value.filter(item => {
      const res = stringSearchProperty ? this.searchInString(item[stringSearchProperty], term) : this.searchInObject(item, term, properties);
      item._filterTextResult = res;
      return res;
    });
  }

  searchInObject(obj: object, term: string, properties: string[] = []): boolean {
    for (const key in obj) {
      if (properties.length && properties.indexOf(key) === -1) {
        continue;
      }
      const val = obj[key];
      if (this.isString(val) && this.searchInString(val, term)) {
        return true;
      }
      if (this.isObject(val) && this.searchInObject(val, term)) {
        return true;
      }
    }

    return false;
  }

  searchInString(str: string, term: string): boolean {
    return str.toLowerCase().indexOf(term) !== -1;
  }

  isObject(val: any): boolean {
    return typeof val === 'object';
  }

  isString(val: any): boolean {
    return typeof val === 'string' || val instanceof String;
  }
}
